module.exports = __webpack_public_path__ + "static/media/CTN_mushroom-magician.f0bbe0c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/CTN_mushroom-magician.jpg
// module id = 236
// module chunks = 1